"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosB2BCustomerUpdateInputSchema = exports.APosB2BCustomerCreateInputSchema = exports.APosB2BCustomerSchema = exports.APosB2BPaymentTermsSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const location_schema_1 = require("./location.schema");
exports.APosB2BPaymentTermsSchema = zod_1.z.enum([
    'net_7', 'net_15', 'net_30', 'net_45', 'net_60', 'cod', 'prepaid',
]);
exports.APosB2BCustomerSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    b2bCustomerId: id_schema_1.EntityIdSchema,
    businessName: zod_1.z.string().min(1).max(200),
    tradingName: zod_1.z.string().max(200).optional(),
    taxId: zod_1.z.string().optional(),
    registrationNumber: zod_1.z.string().optional(),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    billingAddress: location_schema_1.APosAddressSchema.optional(),
    shippingAddress: location_schema_1.APosAddressSchema.optional(),
    paymentTerms: exports.APosB2BPaymentTermsSchema.default('net_30'),
    creditLimit: zod_1.z.number().nonnegative().optional(),
    currentBalance: zod_1.z.number().default(0),
    discountPercent: zod_1.z.number().min(0).max(100).default(0),
    priceListId: id_schema_1.EntityIdSchema.optional(),
    isActive: zod_1.z.boolean().default(true),
    totalOrders: zod_1.z.number().int().nonnegative().default(0),
    totalRevenue: zod_1.z.number().nonnegative().default(0),
    lastOrderDate: zod_1.z.number().optional(),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosB2BCustomerCreateInputSchema = zod_1.z.object({
    businessName: zod_1.z.string().min(1).max(200),
    tradingName: zod_1.z.string().max(200).optional(),
    taxId: zod_1.z.string().optional(),
    registrationNumber: zod_1.z.string().optional(),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    billingAddress: location_schema_1.APosAddressSchema.optional(),
    shippingAddress: location_schema_1.APosAddressSchema.optional(),
    paymentTerms: exports.APosB2BPaymentTermsSchema.optional(),
    creditLimit: zod_1.z.number().nonnegative().optional(),
    discountPercent: zod_1.z.number().min(0).max(100).optional(),
    priceListId: id_schema_1.EntityIdSchema.optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosB2BCustomerUpdateInputSchema = exports.APosB2BCustomerCreateInputSchema.partial().extend({
    isActive: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=b2b-customer.schema.js.map